import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";

import App from "components/App";
import ErrorBoundary from "components/ErrorBoundary";
import { NetworkErrorBoundary } from "components/NetworkErrorBoundary";
import SessionRelatedNetworkErrorHandler from "components/SessionRelatedNetworkErrorHandler";
import CurrentTenantProvider from "contexts/CurrentTenantProvider";
import { AuthnStateProvider } from "contexts/auth";
import { FeatureFlagProvider } from "contexts/featureFlags";
import { LocaleProvider } from "contexts/locale";
import QueryProvider from "contexts/queryClient";
import { ServerVariablesProvider } from "contexts/serverVariables";
import { SessionProvider } from "contexts/session";
import { UIContextProvider } from "contexts/ui";
import VersionedClientProvider from "contexts/versionedClient";
import { wrap as reportErrors } from "services/errorReporter";
import { PusherProvider } from "services/pusher";

const Root = ({ tenantMetadata, locale, pusherConfig, featureFlags, configVariables }) => (
  <Router>
    <CompatRouter>
      <ErrorBoundary type="SWW">
        <NetworkErrorBoundary>
          <ServerVariablesProvider value={configVariables}>
            <FeatureFlagProvider value={featureFlags}>
              <AuthnStateProvider>
                <QueryProvider>
                  <SessionProvider>
                    <PusherProvider config={pusherConfig}>
                      <LocaleProvider initialLocale={locale}>
                        <UIContextProvider>
                          <CurrentTenantProvider
                            tenantID={tenantMetadata.id}
                            tenantVersion={tenantMetadata.versionNumber}
                            requiresAuth={tenantMetadata.requiresAuth}
                            versions={tenantMetadata.versions}
                          >
                            <VersionedClientProvider>
                              <SessionRelatedNetworkErrorHandler />
                              <App />
                            </VersionedClientProvider>
                          </CurrentTenantProvider>
                        </UIContextProvider>
                      </LocaleProvider>
                    </PusherProvider>
                  </SessionProvider>
                </QueryProvider>
              </AuthnStateProvider>
            </FeatureFlagProvider>
          </ServerVariablesProvider>
        </NetworkErrorBoundary>
      </ErrorBoundary>
    </CompatRouter>
  </Router>
);

export default reportErrors(Root);
